// extracted by mini-css-extract-plugin
export default {"Container":"UserInfo_Container__QZhUc","Logo":"UserInfo_Logo__V8ph2","NameAndInfo":"UserInfo_NameAndInfo__8zZ1U","Name":"UserInfo_Name__QZTNp","Info":"UserInfo_Info__b9288"};